<div class="global-container">
	<div class="header flex-r a-center m-bottom-big">
		<mat-icon [svgIcon]="ICONS.LOGO"></mat-icon>
		@if (showNote() && (showCallbackOnCallNote() || showFeedback())) {
			<button (click)="triggerPrint()" class="print-btn no-print" matIconButton="outlined">
				<mat-icon class="material-symbols-outlined">print</mat-icon>
			</button>
		}
	</div>
	<div class="flex-c">
		@if (showNote()) {
			<app-note
				[printMode]="isPrintMode()"
				[forceExpanded]="!showCallbackOnCallNote() && !showFeedback()"
				class="m-bottom-big"
			></app-note>
		}
		@if (showCallbackOnCallNote()) {
			<app-callback-on-callnote></app-callback-on-callnote>
		}
		@if (showFeedback()) {
			<app-callnote-feedback></app-callnote-feedback>
		}
		@if (showSipOrder()) {
			<app-sip-order></app-sip-order>
		}
		@if (showError()) {
			<app-error></app-error>
		}
	</div>
</div>
